import React, { useEffect, useRef, useState } from 'react';
import AppSearch from '@/components/common/AppSearch';
// import VideoSearchSuggestion from './VideoSearchSuggestion';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
// import Api from '@/api';
import { useRouterPath } from '@/functions/routerPath';
import ToolbarIcons from '@/icons/toolbar';
import MoreBox from '@/components/general/MoreBox';
import styles from './styles.module.scss';
import useWindowDimensions from '@/functions/useWindowDimensions';
import seachStyle from './styles.module.scss';
import { setState } from '@/commonTypes';
import Api from '@/api';
import BlogSearch from '@/components/pages/blog/blogsContent/BlogSearch';

interface ToolbarSearchProps {
  className?: string;
  type?: string;
  initial?: string;
  iconFill?: string;
  locale?: string;
  switchType?: boolean;
  setInitialSearch?: setState<string>;
  responsiveLimit?: number;
  placeholder?: string;
  wrapperInput?: string;
}

const ToolbarSearch: React.FC<ToolbarSearchProps> = ({
  className,
  type = 'toolbar',
  initial,
  iconFill,
  locale,
  switchType = true,
  setInitialSearch,
  responsiveLimit = '',
  placeholder = 'جستجو در کارا ...',
  wrapperInput = '',
}) => {
  const router = useRouter();
  const routerPath = useRouterPath();
  const [suggestionList, setSuggestionList] = useState<any[]>([]);
  const [showSuggest, setShowSuggest] = useState(false);
  const [loading, setLoading] = useState(false);
  const suggestionRef = useRef<HTMLDivElement | null>(null);
  const { width } = useWindowDimensions();
  const searchParams = useSearchParams();
  const pathname = usePathname();

  // const callbackSearch = (value: string) => {
  //   if (type == 'toolbar') {
  //     // router.push(routerPath(`/shop?search=${value}`));
  //     const params = new URLSearchParams(searchParams.toString());
  //     params.set('search', value);
  //     router.push(`${'/shop'}${params.toString() ? `?${params.toString()}` : ''}`);
  //   }
  // };

  // const callBackonChangeSuggest = (value: string | undefined) => {
  //   // if (value?.trim()?.length) {
  //   //   setLoading(true);
  //   //   setShowSuggest(true);
  //   // } else {
  //   //   setLoading(false);
  //   //   setShowSuggest(false);
  //   // }
  // };

  // const callBackonChange = (value: string) => {
  //   if (value?.trim()?.length) {
  //     setLoading(true);

  //     if (type == 'toolbar') {
  //       Api.searchAll({ params: { start: 0, limit: 3, q: value, index_string: 'videos_current' } })
  //         .then((res) => {
  //           setSuggestionList(
  //             res?.data?.response?.map((d: { source: object }) => {
  //               return { ...d, ...d.source };
  //             }) || [],
  //           );
  //           setLoading(false);
  //         })
  //         .catch(() => {
  //           setSuggestionList([]);
  //           setLoading(false);
  //         });
  //     }
  //     // else{
  //     //   setInitialSearch && setInitialSearch(value)
  //     // }
  //   } else {
  //     const params = new URLSearchParams(searchParams.toString());
  //     params.delete('search');
  //     router.push(`${pathname}${params.toString() ? `?${params.toString()}` : ''}`);
  //     setSuggestionList([]);
  //   }
  //   setInitialSearch && setInitialSearch(value);
  // };

  // console.log('showSuggest==', showSuggest);

  // useEffect(() => {
  //   if (type == 'toolbar') {
  //     const handleClickOutside = (event: MouseEvent) => {
  //       if (suggestionRef.current && !suggestionRef.current.contains(event.target as Node)) {
  //         setShowSuggest(false);
  //       }
  //     };

  //     document.addEventListener('mousedown', handleClickOutside);
  //     return () => document.removeEventListener('mousedown', handleClickOutside);
  //   }
  // }, [setShowSuggest]);
  // console.log('initial======', initial, width, document.body.clientWidth);
  const renderItem = () => (
    // <AppSearch
    //   ref={suggestionRef}
    //   callbackSearch={callbackSearch}
    //   className={className}
    //   iconFill={iconFill}
    //   callBackonChange={callBackonChange}
    //   callBackonChangeSuggest={callBackonChangeSuggest}
    //   onFocus={() => setShowSuggest(true)}
    //   // initialValue={
    //   //   type == 'toolbar'
    //   //     ? typeof window !== 'undefined' &&
    //   //       typeof document !== 'undefined' &&
    //   //       window?.location.pathname?.includes('/search')
    //   //       ? window.location.pathname.split(/[?#]/)[0].split('/').filter(Boolean).pop() == 'search'
    //   //         ? ''
    //   //         : decodeURIComponent(
    //   //             `${window.location.pathname.split(/[?#]/)[0].split('/').filter(Boolean).pop()}`,
    //   //           )
    //   //       : ''
    //   //     : initial
    //   // }
    //   initialValue={searchParams?.get('search') ? searchParams?.get('search') : initial}
    //   placeholder={placeholder}
    //   wrapperInput={wrapperInput}
    // >
    //   {showSuggest && (
    //     // <VideoSearchSuggestion
    //     //   list={suggestionList}
    //     //   loading={loading}
    //     //   setShowSuggest={setShowSuggest}
    //     // />
    //     <></>
    //   )}
    // </AppSearch>

    <BlogSearch
      page="/search"
      className={`${styles.search}`}
      placeholder={placeholder}
      buttonClassName={`${styles.btn} ${styles.primaryBtn}`}
      searchKey={'q'}
      affix={<></>}
      // setPageNumber={setPageNumber}
    />
  );
  // console.log('width==', width);
  return (
    <>
      {(width && Number(document.body.clientWidth) > Number(responsiveLimit)) || !switchType ? (
        renderItem()
      ) : (
        <MoreBox
          className={`${styles.icon}`}
          icon={<ToolbarIcons.SearchIcon />}
          id={'searchBox'}
          selected={locale}
          boxClassName={`${seachStyle.boxClassName}`}
        >
          {' '}
          {renderItem()}
        </MoreBox>
      )}
    </>
  );
};

export default ToolbarSearch;
